import {
  CLEAR_ENTITIES,
  CLEAR_RESULTS,
  UPDATE_RESULTS,
  UPDATE_ENTITIES,
  UPDATE_TABLES,
  REMOVE_ENTITIES,
  REMOVE_RESULTS,
  REMOVE_TABLES,
  REMOVE_ROW,
  REMOVE_ENTITY_ROW,
  REMOVE_RESULT_ROW,
  OVERWRITE_ENTITIES,
  OVERWRITE_RESULTS,
  OVERWRITE_TABLES
} from './constants'

const removeEntities = (tableName) => ({ type: REMOVE_ENTITIES, tableName })
const removeResults = (tableName) => ({ type: REMOVE_RESULTS, tableName })
const clearEntities = () => ({ type: CLEAR_ENTITIES })
const clearResults = () => ({ type: CLEAR_RESULTS })
const updateTablesAction = (data) => ({ type: UPDATE_TABLES, data })
const removeTables = (tableName) => ({ type: REMOVE_TABLES, tableName })
const removeEntityRow = (tableName, id) => ({ type: REMOVE_ENTITY_ROW, tableName, id })
const removeResultRow = (tableName, id) => ({ type: REMOVE_RESULT_ROW, tableName, id })
const removeRow = (tableName, id) => ({ type: REMOVE_ROW, tableName, id })
const overwriteEntities = (entities) => ({ type: OVERWRITE_ENTITIES, entities })
const overwriteResults = (results) => ({ type: OVERWRITE_RESULTS, results })
const overwriteTables = (data) => ({ type: OVERWRITE_TABLES, data })

const clearTables = () => {
  return dispatch => {
    dispatch(clearEntities())
    dispatch(clearResults())
  }
}

const updateEntities = (entities) => {
  return {
    type: UPDATE_ENTITIES,
    entities
  }
}

const updateResults = (results) => {
  return {
    type: UPDATE_RESULTS,
    results
  }
}


const updateTables = (data) => {
  const { entities, result } = data
  return dispatch => {
    dispatch(updateEntities(entities))
    dispatch(updateResults(result))
    return data
  }
}

export {
  clearEntities,
  clearResults,
  clearTables,
  updateEntities,
  updateResults,
  updateTables,
  updateTablesAction,
  removeTables,
  removeEntities,
  removeResults,
  removeEntityRow,
  removeResultRow,
  removeRow,
  overwriteEntities,
  overwriteResults,
  overwriteTables
}
